

    import { paginationStateHandler } from "@/mixins";
import FormatterService from "@/service/FormatterService";

    export default {
        name: "FundTables",
        mixins: [ paginationStateHandler ],
        props: {
            share: Object,
        },

        data() {
            return {
                format: new FormatterService({
                    currency: 'EUR'
                }),
                sections: [
                    {
                        title: this.$t('component.share.fund.fundTables.section.assetAllocation.title'),
                        headers: [
                            { text: this.$t('component.share.fund.fundTables.section.assetAllocation.headers.asset'), value: 'assetType'},
                            { text: this.$t('component.share.fund.fundTables.section.assetAllocation.headers.percentage'), value: 'assetPercentage', align: 'end', format: 'percent', width: '132px'}
                        ],
                        data: 'assetAllocations'
                    },
                    {
                        title: this.$t('component.share.fund.fundTables.section.largestPositions.title'),
                        headers: [
                            { text: this.$t('component.share.fund.fundTables.section.largestPositions.headers.symbol'), value: 'symbol', width: '90px'},
                            { text: this.$t('component.share.fund.fundTables.section.largestPositions.headers.isin'), value: 'isin', width: '107px'},
                            { text: this.$t('component.share.fund.fundTables.section.largestPositions.headers.name'), value: 'name'},
                            { text: this.$t('component.share.fund.fundTables.section.largestPositions.headers.percentage'), value: 'assetPercentage', align: 'end', format: 'percent', width: '132px'}
                        ],
                        data: 'holdings'
                    },
                    {
                        title: this.$t('component.share.fund.fundTables.section.regionDistribution.title'),
                        headers: [
                            { text: this.$t('component.share.fund.fundTables.section.regionDistribution.headers.region'), value: 'region'},
                            { text: this.$t('component.share.fund.fundTables.section.regionDistribution.headers.percentage'), value: 'assetPercentage', align: 'end', format: 'percent', width: '132px'}
                        ],
                        data: 'worldRegions'
                    },
                    {
                        title: this.$t('component.share.fund.fundTables.section.sectorDistribution.title'),
                        headers: [
                            { text: this.$t('component.share.fund.fundTables.section.sectorDistribution.headers.sector'), value: 'icbNameDe'},
                            { text: this.$t('component.share.fund.fundTables.section.sectorDistribution.headers.percentage'), value: 'assetPercentage', align: 'end', format: 'percent', width: '132px'}
                        ],
                        data: 'sectorWeights'
                    },
                ],
            }
        },

        methods: {
            openShare(isin) {
                this.$router.push({
                    name: this.$getTranslatedRouteName('aktie-share'),
                    params: {
                        share: isin,
                    }
                })
            },
        },
    }
